import {
  Checkbox,
  FormControl,
  FormLabel,
  InputBase,
  MenuItem,
  Select
} from '@material-ui/core'
import { Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { useStyles } from './style'

export function TagsFilter({ onFiltered }) {
  const classes = useStyles()
  const [tags, setTags] = useState([])
  const [selecteds, setSelecteds] = useState([])
  const [searchParam, setSearchParam] = useState('')

  useEffect(() => {
    const loadTags = async () => {
      try {
        const { data } = await api.get(`/tags/list`)
        setTags(data)
      } catch (err) {
        toastError(err)
      }
    }
    loadTags()
  }, [])

  const filteredTags = tags.filter(tag =>
    tag.name?.toLowerCase().includes(searchParam.toLowerCase())
  )

  const handleChange = event => {
    const value = event.target.value
    const selectedTags = tags.filter(tag => value.includes(tag.id))
    setSelecteds(selectedTags)
    onFiltered(selectedTags)
  }

  const selectedIds = selecteds.map(tag => tag.id)
  const renderValue = () => {
    if (selecteds.length === 0) return 'Selecione'
    const text = selecteds.map(option => option.name).join(', ')
    return (
      <span className={classes.selectedText} title={text}>
        {text}
      </span>
    )
  }

  return (
    <FormControl fullWidth className={classes.formControl}>
      <FormLabel id="tags-filter-label">Tags</FormLabel>
      <Select
        labelId="tags-filter-label"
        multiple
        displayEmpty
        variant="outlined"
        value={selectedIds}
        onChange={handleChange}
        renderValue={renderValue}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          getContentAnchorEl: null,
          classes: { paper: classes.menuPaper }
        }}
      >
        <div
          className={classes.searchBox}
          onClick={event => event.stopPropagation()}
          onKeyDown={event => event.stopPropagation()}
        >
          <Search size={16} />
          <InputBase
            className={classes.searchInput}
            placeholder="Pesquisar tag"
            value={searchParam}
            onChange={e => setSearchParam(e.target.value)}
            onClick={event => event.stopPropagation()}
            onKeyDown={event => event.stopPropagation()}
            autoFocus
          />
        </div>
        {filteredTags.length === 0 && (
          <MenuItem disabled value="">
            Nenhuma tag encontrada
          </MenuItem>
        )}
        {filteredTags.map(tag => (
          <MenuItem key={tag.id} value={tag.id}>
            <Checkbox
              className={classes.checkbox}
              checked={selectedIds.includes(tag.id)}
              size="small"
              color="primary"
            />
            {tag.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
